import { CommonResponse, VillageTransportRequestDto } from "@gtpl/shared-models/masters";
import axios from "axios";
import connection from "../connection";

export class VillageTransportCostService{
    URL = connection.DEPLOY_URL + '/village-transport-cost';

    
    

    async saveVillageTransportInfo(req:VillageTransportRequestDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/saveVillageTransportInfo',req)
            .then(res => {
                return res.data
            })
    }
    async getAllVillageTransporationCostData():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllVillageTransporationCostData')
        .then(res=>{
            return res.data
        })
    }
}